// 1 - apple
// 2 - apples
export const pluralize_noun = (count, noun, suffix = 's') =>
  `${noun}${count !== 1 ? suffix : ''}`

// 1 - (apple) gives
// 2 - (apples) give
// `This package includes ${conference_package.person_amount} ${pluralize_noun(conference_package.person_amount, "ticket")} that ${pluralize_verb(conference_package.person_amount, "give")} access to ${conference_package.person_amount} ${pluralize_noun(conference_package.person_amount, "seat")}.`
export const pluralize_verb = (count, verb, suffix = 's') =>
  `${verb}${count !== 1 ? '' : suffix}`
